import { render, staticRenderFns } from "./test-items-view.vue?vue&type=template&id=3be56dc6&scoped=true&"
import script from "./test-items-view.vue?vue&type=script&lang=ts&"
export * from "./test-items-view.vue?vue&type=script&lang=ts&"
import style0 from "./test-items-view.vue?vue&type=style&index=0&id=3be56dc6&prod&lang=scss&scoped=true&"
import style1 from "./test-items-view.vue?vue&type=style&index=1&id=3be56dc6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3be56dc6",
  null
  
)

export default component.exports